import Constants from 'expo-constants'

export const isDev = __DEV__ || Constants?.manifest?.extra?.environment === 'development'

export const isLocal = isDev && Constants?.manifest?.extra?.environment === 'local'

export const isStaging = !isDev && Constants?.manifest?.extra?.environment === 'staging'

export const readable = Constants?.manifest?.extra?.environment

/*
  Production happens only when there is not in the test environment nor the development environment
*/
export const isProd = !isDev && !isStaging

let currentEnv

if (isProd) {
  currentEnv = 'Production'
} else if (isStaging) {
  currentEnv = 'Staging'
} else if (isLocal) {
  currentEnv = 'Local'
} else if (isDev) {
  currentEnv = 'Development'
}

export const environment = currentEnv
